document.addEventListener( 'DOMContentLoaded', () => {
	const btn = document.querySelector( '.anacrm-share-single-btn' );
	const panel = document.querySelector( '.anacrm-share-single-panel' );
	if ( ! btn || ! panel ) {
		return;
	}

	btn.addEventListener( 'click', () => {
		panel.classList.toggle( 'hidden' );
	} );

	panel
		.querySelector( '.anacrm-share-single-close' )
		?.addEventListener( 'click', () => {
			panel.classList.add( 'hidden' );
		} );

	const copyBtn = panel.querySelector( '.anacrm-share-single-copy' );
	if ( copyBtn ) {
		const labelCopy = copyBtn.dataset.labelCopy ?? 'Copy link';
		const labelCopied = copyBtn.dataset.labelCopied ?? 'Copied!';
		copyBtn.addEventListener( 'click', () => {
			navigator.clipboard.writeText( window.location.href ).then( () => {
				copyBtn.textContent = labelCopied;
				setTimeout( () => {
					copyBtn.textContent = labelCopy;
				}, 2000 );
			} );
		} );
	}
} );
